import { render, staticRenderFns } from "./fjzxkbScreen.vue?vue&type=template&id=b6c2625c"
import script from "./fjzxkbScreen.vue?vue&type=script&lang=js"
export * from "./fjzxkbScreen.vue?vue&type=script&lang=js"
import style0 from "./fjzxkbScreen.vue?vue&type=style&index=0&id=b6c2625c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports